export default {
    background_light: '#FAC172', //'#ffd675',
    orange_light: '#f57542', //'#E25B45',//'#f57542',
    dark_red: '#a83232',//'#c94242', //'#a83232',
    dark_green: '#32a840',
    dark_orange: '#c44d2f',
  };